// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2mMEz","info":"Note_info__3wk9H","note":"Note_note__3bT7M","actions":"Note_actions__1GDsS"};